/**
 * Input Schema of UserFilter
 * @author ftgibran
 */
import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {IErroIntegracaoResourcesHolder} from '@/interfaces/resource/IErroIntegracaoResourcesHolder'
import {ErroIntegracaoFilterCollection} from '@/model/filter/ErroIntegracaoFilterCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

export class ErroIntegracaoFilterSchema extends Schema
  implements IErroIntegracaoResourcesHolder {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'ErroIntegracaoFilter'

  readonly fieldSet: FieldSet<ErroIntegracaoFilterCollection> = {
    start: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
      },
    }),
    end: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.allWithPlaceholder(
          $.t('app.all') as string
        ),
      },
    }),
  }
}
